/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
jQuery(function ($) {
    $('.js-info-dropdown-trigger').click(function (e) {
        e.preventDefault();

        let activeClass = 'open';
        let target = $(this).siblings('.js-info-dropdown-reveal');

        if ($(this).hasClass(activeClass)) {
            // Close
            $(this).removeClass(activeClass);
            $(target).slideUp();
        } else {
            // Open
            $(this).addClass(activeClass);
            $(target).slideDown();
        }
    });

    // Source map
    let $map = $('.js-source-map');

    function initMap() {
        let markers = [];
        $map.each(function () {
            let currMap = $(this)[0];

            let lat = $(currMap).data("lat");
            let lng = $(currMap).data("lng");
            let zoom = $(currMap).data('zoom');

            let mapOptions = {
                zoom: zoom,
                scrollwheel: false,
                center: new google.maps.LatLng(lat, lng),
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                streetViewControl: false,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#112532"
                            },
                            {
                                "weight": "0.30"
                            },
                            {
                                "saturation": "0"
                            },
                            {
                                "lightness": "5"
                            },
                            {
                                "gamma": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#d2ab62"
                            },
                            {
                                "saturation": "-20"
                            },
                            {
                                "lightness": "5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#124564"
                            },
                            {
                                "visibility": "off"
                            },
                            {
                                "weight": "6"
                            },
                            {
                                "saturation": "-28"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#e6007e"
                            },
                            {
                                "weight": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "saturation": "18"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.locality",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.locality",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#124564"
                            },
                            {
                                "saturation": "-28"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#112532"
                            },
                            {
                                "visibility": "simplified"
                            },
                            {
                                "saturation": "0"
                            },
                            {
                                "lightness": "5"
                            },
                            {
                                "gamma": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "weight": 8
                            },
                            {
                                "saturation": "-28"
                            },
                            {
                                "lightness": "0"
                            },
                            {
                                "hue": "#ff0000"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#135c6e"
                            },
                            {
                                "weight": 8
                            },
                            {
                                "lightness": "5"
                            },
                            {
                                "gamma": "1"
                            },
                            {
                                "saturation": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#112532"
                            },
                            {
                                "saturation": "0"
                            },
                            {
                                "lightness": "5"
                            },
                            {
                                "gamma": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#112532"
                            },
                            {
                                "saturation": "0"
                            },
                            {
                                "lightness": "5"
                            },
                            {
                                "gamma": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "color": "#328095"
                            },
                            {
                                "saturation": "-28"
                            },
                            {
                                "lightness": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ]
            };

            let mapMarkerIcon = {
                //url: "/assets/images/map-marker.svg",
                //scaledSize: new google.maps.Size(50, 50)
                //origin: new google.maps.Point(0, 0),
                //anchor: new google.maps.Point(0, 0)
            };

            let map = new google.maps.Map(currMap, mapOptions);

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                animation: google.maps.Animation.DROP
                //icon: mapMarkerIcon
            });
            markers.push(marker);
        });
    }

    if ($map.length > 0) {
        google.maps.event.addDomListener(window, 'load', initMap);
    }

    /* ----------------------------------------
       LOAD MORE PRODUCTS
    ---------------------------------------- */
    let $postFilterRevealId = '#post-filters';

    $(document.body).on("click", ".js-load-more-cards", function (e) {
        e.preventDefault();
        let getUrl = $(this).data('page-url') + '&view=data';
        let $btn = $(this);

        $btn.blur();

        $.ajax({
            url: getUrl,
            type: 'GET',
            beforeSend: function () {
                // Set button loading animation
                let btnWidth = $btn.outerWidth();
                $btn.css('min-width', btnWidth);
                $btn.text('');
                $btn.addClass('loading');
            },
            success: function (data) {
                loadInNewProducts(data, $btn, false);
            },
            error: function (data) {
                console.log(data);
            }
        });
    });


    $(document.body).on("change", ".js-product-filter", function (e) {
        let $productFilter = $('.js-product-filter');

        let baseUrl = $('#base-filter-url').val();

        if (baseUrl.indexOf("/search?") >= 0) {
            // Search page
            baseUrl += '&'
        } else {
            // Collection
            baseUrl += '?';
        }

        $productFilter.each(function () {
                if ($(this).attr('type') == 'checkbox') {
                    if ($(this).is(':checked')) {
                        baseUrl += $(this).attr('name') + '=' + $(this).val() + '&';
                    }
                } else if ($(this).attr('type') == 'radio') {
                    if ($(this).is(':checked')) {
                        baseUrl += $(this).attr('name') + '=' + $(this).val() + '&';
                    }
                } else if ($(this).val() != '') {
                    baseUrl += $(this).attr('name') + '=' + $(this).val() + '&';
                }
            }
        );

        baseUrl += 'view=data';

        console.log(baseUrl);

        $.ajax({
            url: baseUrl,
            type: 'GET',
            beforeSend: function () {
            },
            success: function (data) {
                loadInNewProducts(data, null, true, true);
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    function loadInNewProducts(data, $btn = null, emptyGrid = false, openFilters = false) {
        let $listingGrid = $('.js-listing-grid');

        // Set grid height to stop page jumping
        $listingGrid.css('height', $listingGrid.height());

        if (emptyGrid) {
            $listingGrid.empty();
        } else {
            // Hide old btn
            $btn.slideUp('400', function () {
                $btn.parent().remove();
            });
        }

        // Add animate class to new items
        data = data.replace(/js-card-item/g, 'to-animate js-card-item');

        // Keep the filters open if needed
        if(openFilters) {
            data = data.replace(/js-filter-bar-target/g, 'js-filter-bar-target open');
            data = data.replace(/js-filter-reveal/g, 'js-filter-reveal open');
        }

        // Append new data
        $listingGrid.append(data);

        // Set new grid height to we can have nice animation
        $listingGrid.css('height', $listingGrid[0].scrollHeight);

        setTimeout(function () {
            $listingGrid.css('height', 'auto');
        }, 300);

        // Animate in new posts
        let timer = 500;
        let newPosts = $('.to-animate.js-card-item').not('.animated');

        $(newPosts).each(function () {
            let $currPost = $(this);
            setTimeout(function () {
                $currPost.addClass('animated');
            }, timer);

            timer = timer + 150;
        });
    }

    $(document.body).on("click", ".js-sort-reveal", function (e) {
        let activeClass = 'open';
        let target = $(this).siblings('.js-sort-dropdown');

        if($(this).hasClass(activeClass)) {
            // Close
            $(this).removeClass(activeClass);
            $(target).fadeOut();
        } else {
            // Open
            $(this).addClass(activeClass);
            $(target).fadeIn();
        }
    });

    $(document.body).on("click", ".js-filter-reveal", function (e) {
        let activeClass = 'open';
        let $target = $($postFilterRevealId);

        if($(this).hasClass(activeClass)) {
            // Close
            $(this).removeClass(activeClass);
            $target.slideUp();
        } else {
            // Open
            $(this).addClass(activeClass);
            $target.slideDown();
        }
    });

    // Ingredient Slider
    let $ingredientSlider = $('.js-recipe-ingredient-slider');
    if($ingredientSlider.length > 0) {
        $ingredientSlider.each(function(e) {
           let $currSlider = $(this);

            $currSlider.slick({
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 764,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }

    // Recipe/Event Image SLider
    let $recipeImgSlider = $('.js-recipe-image-slider');
    if($recipeImgSlider.length > 0) {
        $recipeImgSlider.each(function (e) {
            let $currSlider = $(this);
            let nav = $currSlider.siblings('.js-recipe-image-slider-nav');

            $currSlider.slick({
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendArrows: $(nav),
                prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor"><path d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"/></svg></button>',
                nextArrow: '<button type="button" class="slick-arrow slick-arrow--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor"><path d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z"/></svg></button>'
            });
        });
    }

    // Accordions
    $('.js-accordion-trigger').click(function(e) {
       e.preventDefault();

       let target = $(this).siblings('.js-accordion-reveal');

       if($(this).hasClass('open')) {
           // Close
           $(this).removeClass('open');
           $(target).slideUp();
       } else {
           // Open
           $(this).addClass('open');
           $(target).slideDown();
       }
    });

    // Testimonial Slider
    let $testimonialSlider = $('.js-testimonial-slider');
    if($testimonialSlider.length > 0) {
        $testimonialSlider.each(function() {
           let $currSlider = $(this);
            let nav = $currSlider.siblings('.js-testimonial-slider-nav');

            $currSlider.slick({
                dots: true,
                infinite: false,
                arrows: false,
                appendDots: $(nav),
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 764,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }
});

document.addEventListener('variant:change', function (event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
    let form = event.target; // The form that triggers the change

    console.log("TEST!");
    console.log(variant);
});

/*-----------------------------------------------
Form Styling
-----------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  //const formContainer = document.querySelector('.form-container');
  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('shopify-forms-embed');
    if (form) {

      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();

      sheet.insertRule(`
      form {
      gap: 24px !important;
      }
      `);

      sheet.insertRule(`
      #form-container-ref h2 {
        font-weight: 600 !important;
        text-transform: uppercase !important;
        letter-spacing: 1.2px;
        font-family: sweet-sans-pro, sans-serif !important;
        font-size: 20px !important;
      }
      `);

      sheet.insertRule(`
      input, button[aria-expanded], textarea {
        border-radius: 0px !important;
        border: 1px solid #999999 !important;
        box-shadow: none !important;
      }
      `);

      sheet.insertRule(`
      input, .phone-country-selector button {
        height: 58px !important;
        box-sizing: border-box !important;
      }
      `); 

            sheet.insertRule(`
      .phone-country-selector button {
        max-height: 58px !important;
      }
      `); 

            sheet.insertRule(`
      form > div:has(textarea)::before {
        border-radius: 0 !important;
        left: 1px !important;
        top: 1px !important;
      }
      `); 

        sheet.insertRule(`
      form > div > p {
        font-weight: 600 !important;
        text-transform: uppercase !important;
        letter-spacing: 1.2px;
        font-family: sweet-sans-pro, sans-serif !important;
        font-size: 12px !important;
      }
      `); 

      sheet.insertRule(`
      label, input {
        font-family: sweet-sans-pro, sans-serif !important;
      }
      `);

      sheet.insertRule(`
      button[type="submit"] {
        background-color: #1F2E47 !important;
        border-radius: 0 !important;
        letter-spacing: 1.4px !important;
        font-weight: 700 !important;
        text-transform: uppercase !important;
        transition: background-color .3s ease;
        padding: 21px 12px !important;
        color: #CB961B !important;
      }
      `);

      sheet.insertRule(`
      button[type="submit"]:hover, button[type="submit"]:focus {
        background-color: #CB961B !important;
        color: #1F2E47 !important;
        filter: unset !important;
      }
      `);



      shadow.adoptedStyleSheets.push(sheet);
      //formContainer.classList.add('loaded');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});